import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en-us/translation.json';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next.use(initReactI18next).init({
  debug: true,
  lng: 'en-US',
  resources: {
    'en-US': {
      translation: en,
    },
  },
  interpolation: {
    format: interpolateFormat,
    escapeValue: false,
  },
});

export function interpolateFormat(value: string, format: string | undefined): string {
  if (format === 'capitalize') {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  if (format !== undefined) {
    // eslint-disable-next-line no-console
    console.warn('Unknown format', format);
  }
  return value;
}
